import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit'
import { AiFeature } from '../../models/AiFeature'
import { RootState } from '../store'

interface AiFeaturesState {
  isLoading: boolean
  aiFeatures: EntityState<AiFeature, string>
}

const aiFeaturesAdapter = createEntityAdapter<AiFeature>()

const initialState: AiFeaturesState = {
  isLoading: true,
  aiFeatures: aiFeaturesAdapter.getInitialState(),
}

export const aiFeaturesSlice = createSlice({
  name: 'aiFeatures',
  initialState,
  reducers: {
    setAiFeaturesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setAiFeatures: (state, action: PayloadAction<AiFeature[]>) => {
      aiFeaturesAdapter.setAll(state.aiFeatures, action.payload)
    },
    resetAiFeatures: () => initialState,
  },
})

export const { setAiFeaturesLoading, setAiFeatures, resetAiFeatures } = aiFeaturesSlice.actions

const aiFeaturesSelectors = aiFeaturesAdapter.getSelectors((state: RootState) => state.meetingSummary.aiFeatures.aiFeatures)

export const selectAiFeatures = (state: RootState) => aiFeaturesSelectors.selectAll(state)
